import React, { useState } from 'react';
import Camera from '../../../../assets/icons/camera.svg';
import CloseIcon from '../../../../assets/icons/close.svg';
import { isEmptyObject } from '../../../../utils';
import { AuthenticatedPUTRequest, reduceImageFileSize } from '../../../../utils';

const GuardianImage = (props) => {
    const { data, isStudent, setState, onError, onClose } = props;
    const [loading, setLoading] = useState(false);
    const [information, setInformation] = useState(data);

    const onChange = async (e) => {
        e.preventDefault();
        let files;
        if (e.dataTransfer) {
            files = e.dataTransfer.files;
        } else if (e.target) {
            files = e.target.files;
        }
        const reader = new FileReader();
        reader.onload = async () => {
            var totalBytes = files[0].size;
            if (files[0].type === 'image/jpeg' || files[0].type === 'image/png') {
                if (totalBytes <= 5000000) {
                    const resizedImage = await reduceImageFileSize(reader.result);
                    setInformation({ ...information, guardian_image_url: resizedImage });
                } else {
                    onError('تصویر کا سائز 5MB سے کم ہونا چاہیے');
                }
            } else {
                onError('مہربانی تصویر کا انتخاب کریں');
            }
        };
        reader.readAsDataURL(files[0]);
    };

    const onSubmit = async (id, updatedInformation) => {
        const { data, success } = await AuthenticatedPUTRequest(
            isStudent ? `students/${id}` : `applicants/${id}`,
            updatedInformation,
        );
        setLoading(false);
        onClose();
        if (!success) {
            onError('براہ کرم دوبارہ کوشش کریں۔');
        } else {
            setState(data);
        }
    };
    const onUpdate = () => {
        setLoading(true);
        var updatedInformation = {};
        for (let key in information) {
            if (key !== 'branch' && key !== 'class_room') {
                if (information[key] !== data[key]) {
                    updatedInformation[key] = information[key];
                }
            }
        }
        if (!isEmptyObject(updatedInformation)) {
            onSubmit(information.id, updatedInformation);
        } else {
            setLoading(false);
            onClose();
        }
    };

    return (
        <div
            className='flex column justifyCenter alignCenter'
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1000,
                background: 'rgba(0,0,0,0.7)',
            }}
        >
            <div
                style={{
                    background: '#ffffff',
                    height: 360,
                    maxHeight: 360,
                    width: 500,
                    borderRadius: 8,
                }}
            >
                <div
                    className='h-100 w-100'
                    style={{ overflow: 'auto', position: 'relative', direction: 'ltr' }}
                >
                    <div
                        className='flex justifyBetween alignCenter w-100'
                        style={{
                            borderBottom: '1px solid #E0E0E0',
                            padding: '20px 16px 8px',
                            height: 72,
                        }}
                    >
                        {isStudent ? (
                            <h2 className='flex alignCenter w-100' style={{ color: '#009688' }}>
                                طالب علم کے سرپرست کی تصویر ترمیم کریں
                            </h2>
                        ) : (
                            <h2 className='flex alignCenter w-100' style={{ color: '#009688' }}>
                                درخواست دہندہ کے سرپرست کی تصویر ترمیم کریں
                            </h2>
                        )}
                        <img
                            src={CloseIcon}
                            alt='close_icon'
                            height={32}
                            width={32}
                            onClick={props.onClose}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>

                    <div
                        className='flex column justifyCenter alignCenter urdu'
                        style={{ padding: 20 }}
                    >
                        <div className='flex column w-100'>
                            <div className='flex justifyCenter alignCenter'>
                                <div className='flex' style={{ position: 'relative' }}>
                                    <img
                                        src={information['guardian_image_url']}
                                        alt='profile'
                                        style={{
                                            width: 160,
                                            height: 160,
                                            borderRadius: '50%',
                                            padding: 1,
                                            border: '1px solid #555',
                                        }}
                                    />
                                    <div
                                        style={{
                                            position: 'absolute',
                                            right: 12,
                                            width: 51.26,
                                            height: 51.26,
                                            bottom: 0,
                                            background: '#FFFFFF',
                                            borderRadius: '50%',
                                            boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.25)',
                                        }}
                                    >
                                        <label
                                            className='flex column alignCenter justifyCenter h-100'
                                            style={{
                                                cursor: 'pointer',
                                                margin: 0,
                                            }}
                                            htmlFor='upload-btn'
                                        >
                                            <img
                                                src={Camera}
                                                alt='camera-icon'
                                                style={{
                                                    height: 32,
                                                    width: 32,
                                                }}
                                            />
                                        </label>
                                        <input
                                            type='file'
                                            id='upload-btn'
                                            accept='image/x-png,image/jpeg'
                                            onChange={onChange}
                                            hidden
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className='flex justifyCenter alignCenter w-100'
                            style={{ height: 64, marginTop: 16 }}
                        >
                            <div className='flex justifyBetween alignCenter'>
                                <div
                                    className='flex justifyEnd alignCenter register_button'
                                    style={{ margin: '0 8px' }}
                                    onClick={() => onUpdate()}
                                >
                                    {loading ? (
                                        <div className='custom_loader' />
                                    ) : (
                                        <h3>{`محفوظ کریں`}</h3>
                                    )}
                                </div>
                                <div
                                    className='flex justifyEnd alignCenter delete_button'
                                    style={{ margin: '0 8px' }}
                                    onClick={() => onClose()}
                                >
                                    <h3>{`منسوخ کریں`}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GuardianImage;
